import useRevealOnce from "./useRevealOnce";

export default function LandingFeatureDock({ features }) {
  const { elementRef, isRevealed } = useRevealOnce();

  return (
    <div
      ref={elementRef}
      className={`landing-feature-dock ${
        isRevealed ? "landing-feature-dock--open" : ""
      }`}
      aria-label="Indicadores do orion33"
    >
      {features.map((feature) => (
        <div className="landing-feature-dock__item" key={feature}>
          {feature}
        </div>
      ))}
    </div>
  );
}
